import React from "react";
import Loader from "./common/Loader/Loader";
import { errorEmail, getCookie } from "./utills";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.isHandlingError = false;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (this.isHandlingError) return;
    this.isHandlingError = true;

    const debugDtls = {
      url: window.location.href,
      sid: getCookie("sid"),
      from: "frontEnd",
      loggedUser: this.props.loggedUser,
      componentStack: info.componentStack
    }
    errorEmail(error, debugDtls)
      .finally(() => {
        this.isHandlingError = false;
      });
  }

  render() {
    if (this.state.hasError) {
      return <Loader />;
    }

    return this.props.children;
  }
}